function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -41.115)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 41.115)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M9.926,59.615a.41.41,0,0,1-.031-.211c.01-.057-.026-.1-.108-.14s-.124-.065-.124-.086-.059-.036-.178-.047l-.178-.016H4.467a2.38,2.38,0,0,1-1.753-.734,2.416,2.416,0,0,1-.729-1.765v-11a2.416,2.416,0,0,1,.729-1.765,2.381,2.381,0,0,1,1.753-.735H9.429a.466.466,0,0,0,.318-.1.52.52,0,0,0,.155-.3,2.648,2.648,0,0,0,.047-.367,3.917,3.917,0,0,0-.008-.414q-.015-.25-.015-.313a.483.483,0,0,0-.147-.352.476.476,0,0,0-.349-.148H4.467a4.287,4.287,0,0,0-3.156,1.32A4.351,4.351,0,0,0,0,45.615v11a4.35,4.35,0,0,0,1.31,3.179,4.285,4.285,0,0,0,3.156,1.321H9.43a.468.468,0,0,0,.318-.1.52.52,0,0,0,.155-.3,2.653,2.653,0,0,0,.047-.367,3.912,3.912,0,0,0-.008-.414Q9.926,59.677,9.926,59.615Z",
  transform: "translate(0 -41.115)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M127.7,59.047l-8.437-8.5a.969.969,0,0,0-1.4,0,.965.965,0,0,0-.295.7v4.5h-6.948a.951.951,0,0,0-.7.3.965.965,0,0,0-.295.7v6a.965.965,0,0,0,.295.7.952.952,0,0,0,.7.3h6.948v4.5a.965.965,0,0,0,.295.7.968.968,0,0,0,1.4,0l8.437-8.5a.987.987,0,0,0,0-1.407Z",
  transform: "translate(-103.996 -49.75)"
})));

var SvgCerrar = function SvgCerrar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCerrar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cerrar.d3e57a3b.svg";
export { ForwardRef as ReactComponent };